export interface Product {
  id: string;
  name: string;
  price: number;
  originalPrice?: number;
  image: string;
  rating: number;
  reviewCount: number;
  category: string;
  sellerId: string;
  seller: {
    name: string;
    avatar: string;
    location: string;
  };
  isNew?: boolean;
  isFeatured?: boolean;
  discount?: number;
  description?: string;
  tags?: string[];
  inStock?: boolean;
  condition?: 'new' | 'used' | 'refurbished';
  brand?: string;
  specifications?: Record<string, string>;
}

export const mockProducts: Product[] = [
  // Electronics
  {
    id: '1',
    name: 'Apple iPhone 15 Pro Max 256GB',
    price: 1199,
    originalPrice: 1299,
    image: 'https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=400&h=300&fit=crop',
    rating: 4.8,
    reviewCount: 1247,
    category: 'Electronics',
    sellerId: 'seller-1',
    seller: {
      name: 'TechStore Pro',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
      location: 'San Francisco, CA'
    },
    isNew: true,
    isFeatured: true,
    discount: 8,
    description: 'The latest iPhone with titanium design, A17 Pro chip, and advanced camera system.',
    tags: ['Smartphone', 'Apple', '5G', 'Camera'],
    inStock: true,
    condition: 'new',
    brand: 'Apple',
    specifications: {
      'Storage': '256GB',
      'Color': 'Natural Titanium',
      'Display': '6.7" Super Retina XDR',
      'Camera': '48MP Main Camera'
    }
  },
  {
    id: '2',
    name: 'Samsung Galaxy S24 Ultra 512GB',
    price: 1299,
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400&h=300&fit=crop',
    rating: 4.7,
    reviewCount: 892,
    category: 'Electronics',
    sellerId: 'seller-1',
    seller: {
      name: 'Mobile World',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face',
      location: 'New York, NY'
    },
    isFeatured: true,
    description: 'Premium Android smartphone with S Pen and advanced AI features.',
    tags: ['Smartphone', 'Samsung', 'S Pen', 'AI'],
    inStock: true,
    condition: 'new',
    brand: 'Samsung'
  },
  {
    id: '3',
    name: 'MacBook Pro 16-inch M3 Pro',
    price: 2499,
    originalPrice: 2699,
    image: 'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=400&h=300&fit=crop',
    rating: 4.9,
    reviewCount: 456,
    category: 'Electronics',
    sellerId: 'seller-1',
    seller: {
      name: 'Apple Store',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=40&h=40&fit=crop&crop=face',
      location: 'Cupertino, CA'
    },
    isNew: true,
    discount: 7,
    description: 'Powerful laptop with M3 Pro chip, perfect for professionals and creators.',
    tags: ['Laptop', 'MacBook', 'M3 Pro', 'Professional'],
    inStock: true,
    condition: 'new',
    brand: 'Apple'
  },
  {
    id: '4',
    name: 'Sony WH-1000XM5 Headphones',
    price: 399,
    originalPrice: 449,
    image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400&h=300&fit=crop',
    rating: 4.6,
    reviewCount: 2156,
    category: 'Electronics',
    sellerId: 'seller-1',
    seller: {
      name: 'Audio Experts',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face',
      location: 'Los Angeles, CA'
    },
    discount: 11,
    description: 'Industry-leading noise canceling wireless headphones with exceptional sound quality.',
    tags: ['Headphones', 'Noise Canceling', 'Wireless', 'Premium'],
    inStock: true,
    condition: 'new',
    brand: 'Sony'
  },

  // Fashion
  {
    id: '5',
    name: 'Nike Air Jordan 1 Retro High',
    price: 170,
    originalPrice: 200,
    image: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop',
    rating: 4.5,
    reviewCount: 3421,
    category: 'Fashion',
    sellerId: 'seller-2',
    seller: {
      name: 'SneakerHead Store',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop&crop=face',
      location: 'Chicago, IL'
    },
    discount: 15,
    description: 'Classic basketball sneakers with premium leather construction.',
    tags: ['Sneakers', 'Basketball', 'Classic', 'Nike'],
    inStock: true,
    condition: 'new',
    brand: 'Nike'
  },
  {
    id: '6',
    name: 'Levi\'s 501 Original Jeans',
    price: 89,
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=300&fit=crop',
    rating: 4.3,
    reviewCount: 1876,
    category: 'Fashion',
    sellerId: 'seller-2',
    seller: {
      name: 'Denim Co.',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
      location: 'Denver, CO'
    },
    description: 'Timeless straight-fit jeans made from 100% cotton denim.',
    tags: ['Jeans', 'Denim', 'Classic', 'Straight Fit'],
    inStock: true,
    condition: 'new',
    brand: 'Levi\'s'
  },
  {
    id: '7',
    name: 'Adidas Ultraboost 22 Running Shoes',
    price: 180,
    image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=400&h=300&fit=crop',
    rating: 4.4,
    reviewCount: 1234,
    category: 'Fashion',
    sellerId: 'seller-2',
    seller: {
      name: 'Running Store',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face',
      location: 'Seattle, WA'
    },
    description: 'High-performance running shoes with responsive Boost midsole technology.',
    tags: ['Running', 'Athletic', 'Boost', 'Performance'],
    inStock: true,
    condition: 'new',
    brand: 'Adidas'
  },

  // Home & Garden
  {
    id: '8',
    name: 'Dyson V15 Detect Cordless Vacuum',
    price: 649,
    originalPrice: 749,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
    rating: 4.7,
    reviewCount: 892,
    category: 'Home & Garden',
    sellerId: 'seller-3',
    seller: {
      name: 'Home Essentials',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=40&h=40&fit=crop&crop=face',
      location: 'Miami, FL'
    },
    discount: 13,
    description: 'Advanced cordless vacuum with laser dust detection and powerful suction.',
    tags: ['Vacuum', 'Cordless', 'Laser Detection', 'Powerful'],
    inStock: true,
    condition: 'new',
    brand: 'Dyson'
  },
  {
    id: '9',
    name: 'KitchenAid Stand Mixer 5-Qt',
    price: 329,
    originalPrice: 399,
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop',
    rating: 4.8,
    reviewCount: 2156,
    category: 'Home & Garden',
    sellerId: 'seller-3',
    seller: {
      name: 'Kitchen Pro',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face',
      location: 'Portland, OR'
    },
    discount: 18,
    description: 'Professional-grade stand mixer perfect for baking enthusiasts.',
    tags: ['Mixer', 'Kitchen', 'Baking', 'Professional'],
    inStock: true,
    condition: 'new',
    brand: 'KitchenAid'
  },

  // Sports & Outdoors
  {
    id: '10',
    name: 'Yeti Rambler 30oz Tumbler',
    price: 45,
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=400&h=300&fit=crop',
    rating: 4.6,
    reviewCount: 3421,
    category: 'Sports & Outdoors',
    sellerId: 'seller-4',
    seller: {
      name: 'Outdoor Gear',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop&crop=face',
      location: 'Austin, TX'
    },
    description: 'Insulated stainless steel tumbler that keeps drinks cold for hours.',
    tags: ['Tumbler', 'Insulated', 'Stainless Steel', 'Cold'],
    inStock: true,
    condition: 'new',
    brand: 'Yeti'
  },
  {
    id: '11',
    name: 'Patagonia Better Sweater Fleece',
    price: 99,
    image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',
    rating: 4.5,
    reviewCount: 1876,
    category: 'Sports & Outdoors',
    sellerId: 'seller-4',
    seller: {
      name: 'Mountain Store',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
      location: 'Boulder, CO'
    },
    description: 'Sustainable fleece jacket made from recycled polyester.',
    tags: ['Fleece', 'Sustainable', 'Outdoor', 'Recycled'],
    inStock: true,
    condition: 'new',
    brand: 'Patagonia'
  },

  // Books & Media
  {
    id: '12',
    name: 'The Psychology of Money',
    price: 16,
    originalPrice: 20,
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=300&fit=crop',
    rating: 4.7,
    reviewCount: 892,
    category: 'Books & Media',
    sellerId: 'seller-5',
    seller: {
      name: 'Book Lovers',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face',
      location: 'Boston, MA'
    },
    discount: 20,
    description: 'Timeless lessons on wealth, greed, and happiness by Morgan Housel.',
    tags: ['Finance', 'Psychology', 'Wealth', 'Bestseller'],
    inStock: true,
    condition: 'new',
    brand: 'Harriman House'
  },

  // Beauty & Health
  {
    id: '13',
    name: 'The Ordinary Niacinamide 10% + Zinc 1%',
    price: 12,
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8b03?w=400&h=300&fit=crop',
    rating: 4.4,
    reviewCount: 1234,
    category: 'Beauty & Health',
    sellerId: 'seller-6',
    seller: {
      name: 'Beauty Store',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=40&h=40&fit=crop&crop=face',
      location: 'Los Angeles, CA'
    },
    description: 'High-strength vitamin and mineral blemish formula for clearer skin.',
    tags: ['Skincare', 'Niacinamide', 'Zinc', 'Blemish'],
    inStock: true,
    condition: 'new',
    brand: 'The Ordinary'
  },

  // Automotive
  {
    id: '14',
    name: 'Tesla Model 3 Floor Mats Set',
    price: 199,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
    rating: 4.6,
    reviewCount: 456,
    category: 'Automotive',
    sellerId: 'seller-7',
    seller: {
      name: 'Tesla Accessories',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face',
      location: 'Fremont, CA'
    },
    description: 'Premium all-weather floor mats designed specifically for Tesla Model 3.',
    tags: ['Floor Mats', 'Tesla', 'All-Weather', 'Premium'],
    inStock: true,
    condition: 'new',
    brand: 'Tesla'
  },

  // Toys & Games
  {
    id: '15',
    name: 'LEGO Creator 3-in-1 Space Shuttle',
    price: 79,
    originalPrice: 99,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
    rating: 4.8,
    reviewCount: 2156,
    category: 'Toys & Games',
    sellerId: 'seller-8',
    seller: {
      name: 'Toy World',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop&crop=face',
      location: 'Orlando, FL'
    },
    discount: 20,
    description: 'Build 3 different space vehicles with this creative LEGO set.',
    tags: ['LEGO', 'Space', 'Creative', 'Building'],
    inStock: true,
    condition: 'new',
    brand: 'LEGO'
  }
];

export const categories = [
  'All Categories',
  'Electronics',
  'Fashion',
  'Home & Garden',
  'Sports & Outdoors',
  'Books & Media',
  'Beauty & Health',
  'Automotive',
  'Toys & Games'
];

export const sortOptions = [
  { value: 'relevance', label: 'Relevance' },
  { value: 'price-low', label: 'Price: Low to High' },
  { value: 'price-high', label: 'Price: High to Low' },
  { value: 'rating', label: 'Highest Rated' },
  { value: 'newest', label: 'Newest First' },
  { value: 'popular', label: 'Most Popular' }
];

export const priceRanges = [
  { label: 'Under $25', min: 0, max: 25 },
  { label: '$25 - $50', min: 25, max: 50 },
  { label: '$50 - $100', min: 50, max: 100 },
  { label: '$100 - $250', min: 100, max: 250 },
  { label: '$250 - $500', min: 250, max: 500 },
  { label: 'Over $500', min: 500, max: Infinity }
];

export const conditions = [
  { value: 'all', label: 'All Conditions' },
  { value: 'new', label: 'New' },
  { value: 'used', label: 'Used' },
  { value: 'refurbished', label: 'Refurbished' }
];
